import type { NaturesFichierProvider } from '@/features/domaine/types/opco'
import type { ContratProADTO } from '@/features/api/extranet/dto/Demande/PROA'
import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'

export const NATURE_PROA = 'NATURE_PROA' as const
export const naturesFichiersProa: NaturesFichierProvider<ContratProADTO> = {
  getNaturesFichiers: (_demande, typeContext) => {
    let obligatoires = ['Cerfa', 'Convention']
    let facultatifs = ['Autre']
    let facultatifsDefaut: string[] = []

    if (typeContext === TypesContextesAutorisesEnum.Prestataire) {
      facultatifs = [...obligatoires, ...facultatifs]
      facultatifsDefaut = [...obligatoires, ...facultatifsDefaut]
      obligatoires = []
    }
    return {
      obligatoires: obligatoires,
      facultatifs: facultatifs,
      facultatifsDefaut: facultatifsDefaut,
      /* Si absent, prend valeur par défaut. Peut-etre calculé. Exemple :
        {
            'Cerfa': 10,
            'Convention': 2
        }
    */
      nombreFichiersMaximum: {},
      nombreFichiersMinimum: {},
    }
  },

  key: NATURE_PROA,
}
